import { Form } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { updateCurrentQueryDetiails } from '../../../actions/query';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import InputNumberWithSlider from '../InputNumberWithSlider';

const NodeLimit = ({ values, setValues }: any) => {
  const onChange = (value: number) => {
    setValues({ ...values, nodeLimit: value });
  };
  return (
    <div id="node-limit" className="w-full mt-5">
      <Form.Item labelCol={{ span: 24 }} label="# of Neighbors">
        <div>
          <InputNumberWithSlider
            value={values.nodeLimit}
            onChange={onChange}
            min={1}
            max={50}
            step={1}
          />
        </div>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeLimit);
